<template>
    <main class="container">
        <b-row>
            <b-col class="col-lg-2"></b-col>
            <b-col class="col-lg-8" style="border-radius: 1.5em; border: 2px solid #b2b2b2; padding: 1.2em;margin-top: 1.8em; margin-bottom: 3em; padding-left 1em;" >
                <!-- <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h3> Thank You! </h3>
                    </b-col>
                </b-row> -->
                
                 <b-row>
                    <b-col class="col-lg-12 text-center">
                         <h1>You have successfully submitted your rebate! </h1>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">

                        &nbsp;
                    </b-col>
                </b-row>
                
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h3>Confirmation Number:</h3><h5>  {{this.$route.query.docID}} </h5>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">

                        &nbsp;
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h4>If sending by mail, please print and send with copies of your invoice(s) to:</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h4>Hydro Rebate Headquarters</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h4>P.O. Box 54989</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h4>Cincinnati, OH 45254-0989</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">

                        &nbsp;
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">

                        &nbsp;
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h4>Please contact Hydro Rebate HQ Customer Service with questions:</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 text-center">
                        <h4>+1 (855) 236 7384</h4>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="col-lg-2" ></b-col>
        </b-row>
        <b-row align-h="center">
            <b-col class="">
                    <router-link to="/"><b-button class="btn mx-auto">Return to Home</b-button></router-link>
            </b-col>
        </b-row>
    </main>
</template>

<script>
import "../../node_modules/@fortawesome/fontawesome-free/css/all.css"
import * as firebase from 'firebase';
import 'firebase/firestore';


export default {
  name: 'rebateConfirmation',
  data () {
    return {
        firstName: null,
        lastName: null,
        conNumber: null
    }
  },
  methods: {

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn {
    border-radius: 25px;
    width: 200px;
    display: block;
    margin-top: 5px;
    color: #fefefe;
    background-color: #0082bf;
    padding: 5px;
    cursor: pointer;
    margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/RebateEntryConfirmation.vue